import { nanoid } from 'nanoid'
import { useLocation } from 'react-router-dom'
import Terms from './Terms'

export default function Navigation() {

    const active = useLocation().hash.toLowerCase().split("%20").join(" ").split("#").join("")

    
  return (
    <>
        {/* rendered on small screens */}
        <nav className="w-full flex overflow-auto p-2 bg-black/5 lg:hidden">
            <a 
                className={active === "eula" ?"px-3 py-1 rounded border border-red-1 border-black/30 mr-2 last:mr-0 bg-black text-white":"px-3 py-1 rounded border border-red-1 border-black/30 mr-2 last:mr-0"}
                href="#eula"
            >
                EULA
            </a>
            {
                Terms.map((term)=>(
                    <a 
                        key={nanoid(5)}
                        href={`#${term.title}`} 
                        className={active === term.title.toLowerCase() ? "px-3 py-1 rounded border border-red-1 border-black/30 mr-2 last:mr-0 bg-black text-white" : "px-3 py-1 rounded border border-red-1 border-black/30 mr-2 last:mr-0"}
                    >
                        <span className='whitespace-nowrap text-sm capitalize'>
                            {term.title}
                        </span>
                    </a>
                ))
            }
        </nav>

        {/* rendered on large screens */}
        <nav className="hidden lg:block w-1/6 h-full overflow-auto bg-red shadow-lg shadow-black/20">
            <a 
                href="#eula" 
                key={nanoid(5)} 
                className={active === "eula" ? "flex items-start w-full p-4 border-b border-b-black/10 hover:bg-black/5 bg-black/5 border border-l-4 border-l-primary" : "flex items-start w-full p-4 border-b border-b-black/10 hover:bg-black/5"} 
            >
                <div className="h-6 w-6">
                    {1}.
                </div>
                <span className="text-gray-500">EULA</span>
            </a>
            {
                Terms.map((term, idx)=>(
                    <a 
                        href={`#${term.title}`} 
                        key={nanoid(5)} 
                        className={active === term.title.toLowerCase() ? "flex items-start w-full p-4 border-b border-b-black/10 hover:bg-black/5 bg-black/5 border border-l-4 border-l-primary" : "flex items-start w-full p-4 border-b border-b-black/10 hover:bg-black/5"} 
                    >
                        <div className="h-6 w-6">
                            {idx+2}.
                        </div>
                        <span className="text-gray-500">{term.title}</span>
                    </a>
                ))
            }
        </nav>
    </>
  )
}
